var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var AwareIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 63,
    glyphHeight: 33
  }), React.createElement("path", {
    d: "M59.02 9.64047C58.5 9.30047 46.6 1.72047 32.68 1.12047C32.14 1.04047 31.58 0.980469 31 0.980469C30.42 0.980469 29.88 1.04047 29.32 1.12047C15.4 1.70047 3.85998 9.34047 3.35998 9.68047L0.039978 11.9205L4.49998 18.5605L7.81998 16.3205C7.81998 16.3205 12.54 13.2005 19.16 11.0805C19.06 11.7005 19 12.3405 19 13.0005C19 19.6205 24.38 25.0005 31 25.0005C37.62 25.0005 43 19.6205 43 13.0005C43 12.3405 42.94 11.6805 42.82 11.0405C49.66 13.1805 54.58 16.3005 54.66 16.3605L58.02 18.5405L62.38 11.8205L59.02 9.64047ZM35 13.0005C35 15.2005 33.2 17.0005 31 17.0005C28.8 17.0005 27 15.2005 27 13.0005C27 11.1005 28.34 9.50047 30.12 9.10047C30.42 9.10047 30.7 9.06047 31 9.06047C31.3 9.06047 31.58 9.08047 31.88 9.10047C33.66 9.50047 35 11.1005 35 13.0005Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M46.14 23.3397C46.14 23.3397 38.38 28.3997 31 28.3997C23.62 28.3997 14.86 23.3197 14.78 23.2797L13.06 22.2597L11.04 25.6997L12.76 26.7197C13.16 26.9597 22.48 32.3997 31.02 32.3997C39.56 32.3997 48 26.8997 48.36 26.6597L50.02 25.5597L47.82 22.2197L46.16 23.3197L46.14 23.3397Z",
    fill: "black"
  }));
};
export var AwareIconGlyph = function (props) {
  return React.createElement(AwareIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};